import React, { useContext } from 'react';

const IsUserLoggedContext = React.createContext();

export const IsUserLoggedProvider = IsUserLoggedContext.Provider;
export const IsUserLoggedConsumer = IsUserLoggedContext.Consumer;

export const useIsUserLoggedContext = () => useContext(IsUserLoggedContext);

export default {
  IsUserLoggedProvider,
  IsUserLoggedConsumer,
  useIsUserLoggedContext
};
